import React from "react";
import { FormHelperText, InputLabel, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { relationsData } from "./data";

const AutoCompleteRelations = ({ name, label, value, error, required, helperText, onChange }) => {
  return (
    <>
      <div>
        <InputLabel shrink={true} id="relation-label">
          {label} {required ? <span style={{ color: error ? "#f44336" : "#000" }}>{`*`}</span> : ""}
        </InputLabel>
        <Autocomplete
          name={name}
          size="small"
          value={value}
          options={relationsData}
          getOptionLabel={(option) => option.label}
          onChange={onChange}
          InputLabelProps={{
            shrink: true,
          }}
          renderInput={(params) => (
            <div className="select-field">
              <TextField
                {...params}
                variant="standard"
                placeholder="Select Relationship"
                error={error}
              />
            </div>
          )}
        />
        {error ? (
          <FormHelperText>
            <span style={{ color: "#f44336" }}>{helperText}</span>
          </FormHelperText>
        ) : null}
      </div>
    </>
  );
};

export default AutoCompleteRelations;

AutoCompleteRelations.defaultProps = {};
